import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import Spinner from '../../Elements/ProgressIndicator/Circular/Spinner/Spinner'
import { LoadingOverlay } from '../../Layout/LoadingOverlay/LoadingOverlay'

export function Redirect({
  to,
  replace = false,
  reload = false,
  inline,
}: {
  to: string
  replace?: boolean
  reload?: boolean
  inline?: boolean
}) {
  const navigate = useNavigate()

  useEffect(() => {
    if (reload || to.startsWith('http')) {
      if (replace) {
        window.location.replace(to)
      } else {
        window.location.href = to
      }
    } else {
      navigate(to, { replace })
    }
  }, [reload, to, replace, navigate])

  return inline ? (
    <Spinner className="mx-auto" />
  ) : (
    <LoadingOverlay id="Redirect" open />
  )
}
